import { render, staticRenderFns } from "./DirectionView.vue?vue&type=template&id=955f9b4a&scoped=true&"
import script from "./DirectionView.vue?vue&type=script&lang=js&"
export * from "./DirectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955f9b4a",
  null
  
)

export default component.exports